export default {
  noConversationsMessage: 'No Conversations'
};
